import React, {useEffect, useState} from 'react';
import axios from 'axios';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import './listEvent.css';
import jwt_decode from 'jwt-decode';
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'



const ListEvent = () => {

    const [reward, setReward] = useState([])
    const [id, setId] = useState('')
 
    const popupValidate = () => {
      Swal.fire({
          position: 'center',
          icon: 'success',
          title: `Ta participation à cet évenement à bien été pris en compte !`,
          showConfirmButton: false,
          timer: 3000
      })
  }


    useEffect(() => {
        getId()
        getReward()
          }, [])


    const getId = () => {
    if (localStorage.userToken) {
      const token = localStorage.userToken
      const decoded = jwt_decode(token)
      setId(decoded.id)

    }
  }
      const getReward = () => {
        axios.get(`https://clean-my-calanques.herokuapp.com/rewards`)
          .then(response => setReward(response.data))
          .catch(err => console.error(err))
      }


    const selectEvent = async (e)=> {
        const sentEvent = {UserId : localStorage.userId,EventId : e.id, role : "Participant"} 
        await axios.post("https://clean-my-calanques.herokuapp.com/reward",sentEvent)
          .then(x => popupValidate())
          .catch(err => console.log(err)) 
          console.log(sentEvent)
      }


    const useStyles = makeStyles({
      card: {
        maxWidth: 320,  
        minWidth: 320,
        margin: 'auto',
        marginBottom: '10vh',
        justifyContent: 'center' 
        
      },

    });
      const classes = useStyles();
    

      console.log(reward)

     return(
<>

<h1 className='titreEvent'>Prochains évènements</h1>

    <div className='cardEvent'>
      {reward.map(e => {
        console.log(e)
return(
        <Card className={classes.card}>
          <CardActionArea>
            <CardMedia
              component="img"
              alt="imgevent"
              height="140"
              image= {e.Event.url}
              title={e.Event.name}
            />
            <CardContent>
              <Typography gutterBottom variant="h5" component="h1">
               {e.Event.name}
              </Typography>
              <Typography variant="body2" component="h2">
                {e.Event.mission}
              </Typography>
              <Typography variant="body2" color="textSecondary" component="p">
                
            
                  <>
                  <p>Organisateur : {e.User.firstname} {e.User.lastname}</p>
                  <p>Contact : {e.User.phone}</p>
                  <p>Nombre de participants : {e.nbr_participants}</p>
                  </>
                  

              </Typography>
            </CardContent>
          </CardActionArea>
          <CardActions>
              { localStorage.userId ? (
                  <>
            <Button onClick={() => selectEvent(e)} color="danger" size="sm ">
              Je participe
            </Button>
            </>
            ) : (
null
            )}
          </CardActions>
        </Card>


        )
})} 

     
</div>  
</> 
     ) 

}

export default ListEvent;